import React, { FC } from 'react';
import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListIconText: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListIconText.slug = block.slug;
ListIconText.title = block.title;
